import { render, staticRenderFns } from "./Suorganizatori.vue?vue&type=template&id=c46fd4e6&scoped=true&"
import script from "./Suorganizatori.vue?vue&type=script&lang=js&"
export * from "./Suorganizatori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46fd4e6",
  null
  
)

export default component.exports